/**
 * Generated by orval 🍺
 * Do not edit manually.
 * DeadDrop
 * Agent coordination service with MCP and REST interfaces
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  CreateOnboardingApiKeyRequest,
  CreateOnboardingApiKeyResponse,
  HTTPValidationError,
  OnboardingStateResponse,
  ResetOnboardingRequest,
  ResetOnboardingResponse,
  SendTestMessageRequest,
  SendTestMessageResponse,
  UpdateOnboardingStateRequest
} from '../model';

import { apiMutator } from '../../../lib/api-mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Create API key connection for onboarding wizard.
 *
 * Generates connection with full read/write permissions using default name
 * "Onboarding API Key". Validates topic ownership before connection creation.
 *
 * Args:
 *     req_obj: Request with topic_id and connection_type
 *     request: FastAPI request for rate limiting
 *     response: FastAPI response for headers
 *     current_user: Authenticated user from Clerk
 *
 * Returns:
 *     Success flag, created connection ID, and plaintext API key (only shown once)
 *
 * Raises:
 *     HTTPException: 401 if authentication fails
 *     TopicNotFoundError: 404 if topic not found
 *     TopicAccessDeniedError: 403 if user doesn't own topic
 * @summary Create Api Key
 */
export const createApiKeyV1OnboardingApiKeyPost = (
    createOnboardingApiKeyRequest: CreateOnboardingApiKeyRequest,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<CreateOnboardingApiKeyResponse>(
      {url: `/v1/onboarding/api-key`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createOnboardingApiKeyRequest, signal
    },
      options);
    }




export const getCreateApiKeyV1OnboardingApiKeyPostMutationKey = () => ['createApiKeyV1OnboardingApiKeyPost'] as const;

export const getCreateApiKeyV1OnboardingApiKeyPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createApiKeyV1OnboardingApiKeyPost>>, TError,CreateApiKeyV1OnboardingApiKeyPostMutationVariables, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof createApiKeyV1OnboardingApiKeyPost>>, TError,CreateApiKeyV1OnboardingApiKeyPostMutationVariables, TContext> => {

const mutationKey = getCreateApiKeyV1OnboardingApiKeyPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createApiKeyV1OnboardingApiKeyPost>>, CreateApiKeyV1OnboardingApiKeyPostMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createApiKeyV1OnboardingApiKeyPost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateApiKeyV1OnboardingApiKeyPostMutationResult = NonNullable<Awaited<ReturnType<typeof createApiKeyV1OnboardingApiKeyPost>>>
    export type CreateApiKeyV1OnboardingApiKeyPostMutationBody = CreateOnboardingApiKeyRequest
    export type CreateApiKeyV1OnboardingApiKeyPostMutationError = HTTPValidationError
    export type CreateApiKeyV1OnboardingApiKeyPostMutationVariables = {data: CreateOnboardingApiKeyRequest}

    /**
 * @summary Create Api Key
 */
export const useCreateApiKeyV1OnboardingApiKeyPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createApiKeyV1OnboardingApiKeyPost>>, TError,CreateApiKeyV1OnboardingApiKeyPostMutationVariables, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createApiKeyV1OnboardingApiKeyPost>>,
        TError,
        CreateApiKeyV1OnboardingApiKeyPostMutationVariables,
        TContext
      > => {
      return useMutation(getCreateApiKeyV1OnboardingApiKeyPostMutationOptions(options), queryClient);
    }
    /**
 * Reset onboarding wizard state while preserving user profile data.
 *
 * Clears onboarding completion flags and progress. Preserves user profile fields
 * (useCase, companySize, attribution, termsAccepted, termsAcceptedAt).
 *
 * Args:
 *     req_obj: Empty request body
 *     request: FastAPI request for rate limiting
 *     response: FastAPI response for headers
 *     current_user: Authenticated user from Clerk
 *
 * Returns:
 *     Success flag and confirmation message
 *
 * Raises:
 *     HTTPException: 401 if authentication fails
 * @summary Reset State
 */
export const resetStateV1OnboardingResetPost = (
    resetOnboardingRequest: ResetOnboardingRequest,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<ResetOnboardingResponse>(
      {url: `/v1/onboarding/reset`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: resetOnboardingRequest, signal
    },
      options);
    }




export const getResetStateV1OnboardingResetPostMutationKey = () => ['resetStateV1OnboardingResetPost'] as const;

export const getResetStateV1OnboardingResetPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetStateV1OnboardingResetPost>>, TError,ResetStateV1OnboardingResetPostMutationVariables, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof resetStateV1OnboardingResetPost>>, TError,ResetStateV1OnboardingResetPostMutationVariables, TContext> => {

const mutationKey = getResetStateV1OnboardingResetPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetStateV1OnboardingResetPost>>, ResetStateV1OnboardingResetPostMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  resetStateV1OnboardingResetPost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetStateV1OnboardingResetPostMutationResult = NonNullable<Awaited<ReturnType<typeof resetStateV1OnboardingResetPost>>>
    export type ResetStateV1OnboardingResetPostMutationBody = ResetOnboardingRequest
    export type ResetStateV1OnboardingResetPostMutationError = HTTPValidationError
    export type ResetStateV1OnboardingResetPostMutationVariables = {data: ResetOnboardingRequest}

    /**
 * @summary Reset State
 */
export const useResetStateV1OnboardingResetPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetStateV1OnboardingResetPost>>, TError,ResetStateV1OnboardingResetPostMutationVariables, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetStateV1OnboardingResetPost>>,
        TError,
        ResetStateV1OnboardingResetPostMutationVariables,
        TContext
      > => {
      return useMutation(getResetStateV1OnboardingResetPostMutationOptions(options), queryClient);
    }
    /**
 * Update onboarding wizard state in Clerk publicMetadata.
 *
 * Supports partial updates with merge semantics. Preserves existing onboarding
 * progress fields not specified in request. Validates constraints: current_step
 * range 1-6, completed/skipped mutual exclusion.
 *
 * Args:
 *     req_obj: State update request with optional fields
 *     request: FastAPI request for rate limiting
 *     response: FastAPI response for headers
 *     current_user: Authenticated user from Clerk
 *
 * Returns:
 *     Success flag and updated onboarding progress from Clerk metadata
 *
 * Raises:
 *     HTTPException: 401 if authentication fails
 *     ValidationError: 400 if completed and skipped both True
 *     ValidationError: 422 if current_step out of range 1-6
 * @summary Update State
 */
export const updateStateV1OnboardingStatePatch = (
    updateOnboardingStateRequest: UpdateOnboardingStateRequest,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<OnboardingStateResponse>(
      {url: `/v1/onboarding/state`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateOnboardingStateRequest, signal
    },
      options);
    }




export const getUpdateStateV1OnboardingStatePatchMutationKey = () => ['updateStateV1OnboardingStatePatch'] as const;

export const getUpdateStateV1OnboardingStatePatchMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStateV1OnboardingStatePatch>>, TError,UpdateStateV1OnboardingStatePatchMutationVariables, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof updateStateV1OnboardingStatePatch>>, TError,UpdateStateV1OnboardingStatePatchMutationVariables, TContext> => {

const mutationKey = getUpdateStateV1OnboardingStatePatchMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateStateV1OnboardingStatePatch>>, UpdateStateV1OnboardingStatePatchMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateStateV1OnboardingStatePatch(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateStateV1OnboardingStatePatchMutationResult = NonNullable<Awaited<ReturnType<typeof updateStateV1OnboardingStatePatch>>>
    export type UpdateStateV1OnboardingStatePatchMutationBody = UpdateOnboardingStateRequest
    export type UpdateStateV1OnboardingStatePatchMutationError = HTTPValidationError
    export type UpdateStateV1OnboardingStatePatchMutationVariables = {data: UpdateOnboardingStateRequest}

    /**
 * @summary Update State
 */
export const useUpdateStateV1OnboardingStatePatch = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStateV1OnboardingStatePatch>>, TError,UpdateStateV1OnboardingStatePatchMutationVariables, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateStateV1OnboardingStatePatch>>,
        TError,
        UpdateStateV1OnboardingStatePatchMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateStateV1OnboardingStatePatchMutationOptions(options), queryClient);
    }
    /**
 * Send test message to topic during onboarding wizard.
 *
 * Creates test message with custom content using first available connection
 * for topic. Validates topic ownership before message creation.
 *
 * Args:
 *     req_obj: Request with topic_id and content for test message
 *     request: FastAPI request for rate limiting
 *     response: FastAPI response for headers
 *     current_user: Authenticated user from Clerk
 *
 * Returns:
 *     Success flag, created message ID, and topic name
 *
 * Raises:
 *     HTTPException: 401 if authentication fails
 *     TopicNotFoundError: 404 if topic not found
 *     TopicAccessDeniedError: 403 if user doesn't own topic
 *     ConnectionError: 400 if no connections available for topic
 *     ValidationError: 422 if content exceeds 1024 characters (Pydantic) or 1024 bytes (service)
 * @summary Create Test Message
 */
export const createTestMessageV1OnboardingTestMessagePost = (
    sendTestMessageRequest: SendTestMessageRequest,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<SendTestMessageResponse>(
      {url: `/v1/onboarding/test-message`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendTestMessageRequest, signal
    },
      options);
    }




export const getCreateTestMessageV1OnboardingTestMessagePostMutationKey = () => ['createTestMessageV1OnboardingTestMessagePost'] as const;

export const getCreateTestMessageV1OnboardingTestMessagePostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTestMessageV1OnboardingTestMessagePost>>, TError,CreateTestMessageV1OnboardingTestMessagePostMutationVariables, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof createTestMessageV1OnboardingTestMessagePost>>, TError,CreateTestMessageV1OnboardingTestMessagePostMutationVariables, TContext> => {

const mutationKey = getCreateTestMessageV1OnboardingTestMessagePostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTestMessageV1OnboardingTestMessagePost>>, CreateTestMessageV1OnboardingTestMessagePostMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createTestMessageV1OnboardingTestMessagePost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTestMessageV1OnboardingTestMessagePostMutationResult = NonNullable<Awaited<ReturnType<typeof createTestMessageV1OnboardingTestMessagePost>>>
    export type CreateTestMessageV1OnboardingTestMessagePostMutationBody = SendTestMessageRequest
    export type CreateTestMessageV1OnboardingTestMessagePostMutationError = HTTPValidationError
    export type CreateTestMessageV1OnboardingTestMessagePostMutationVariables = {data: SendTestMessageRequest}

    /**
 * @summary Create Test Message
 */
export const useCreateTestMessageV1OnboardingTestMessagePost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTestMessageV1OnboardingTestMessagePost>>, TError,CreateTestMessageV1OnboardingTestMessagePostMutationVariables, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createTestMessageV1OnboardingTestMessagePost>>,
        TError,
        CreateTestMessageV1OnboardingTestMessagePostMutationVariables,
        TContext
      > => {
      return useMutation(getCreateTestMessageV1OnboardingTestMessagePostMutationOptions(options), queryClient);
    }
